<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card :loading="loading" class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span class="headline"
          >{{ originalScreen ? "Editar" : "Agregar" }} pantalla</span
        >
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col v-if="!originalScreen" cols="12" sm="12" md="12">
              <v-text-field
                v-model="code"
                label="Código de la pantalla"
                autofocus
                rounded
                ref="code"
                filled
                clearable
                v-on:keyup.enter="search"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="12" md="12">
              <v-row justify="end">
                <v-btn
                  v-if="!result && !originalScreen"
                  :loading="loading"
                  class="save-btn"
                  @click="search()"
                  color="btn-color"
                  >Buscar</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog
      persistent
      max-width="700px"
      v-if="addScreenDialog"
      v-model="addScreenDialog"
    >
      <configure-screen
        :new="true"
        :result="result"
        :selectedApp="selectedApp"
        :code="code"
        :selectedCountry="selectedCountry"
        :selectedCity="selectedCity"
        :selectedAgency="selectedAgency"
        :key="randomKey"
        :countries="countries"
        :originalScreen="selectedScreen"
        @success="$emit('success')"
        @cancel="addScreenDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";
import configureScreen from "./configure-screen";

export default {
  name: "add-screen",
  components: {
    configureScreen,
  },
  props: [
    "originalScreen",
    "countries",
    "selectedCountry",
    "selectedApp",
    "selectedCity",
    "selectedAgency",
    "code",
  ],
  data() {
    return {
      result: null,
      snackbarText: "",
      snackbar: false,
      loading: false,
      playlists: [],
      cities: [],
      addScreenDialog: false,
      agencies: [],
    };
  },
  computed: {
    ...mapState(["user", "groupId"]),
  },

  methods: {
    search() {
      if (this.code) {
        this.loading = true;
        db.collection("tempScreens")
          .where("code", "==", parseInt(this.code))
          .get()
          .then((response) => {
            if (response.size == 0) {
              this.snackbarText = `No se encontró ninguna pantalla asociada al código ${this.code}`;
              this.snackbar = true;
            } else {
              if (response.docs[0].data().uuid) {
                this.result = response.docs[0].data();
                this.result.id = response.docs[0].id;
                this.addScreenDialog = true;
              } else {
                this.snackbarText =
                  "La pantalla encontrada no tiene los campos requeridos, inténtelo nuevamente.";
                this.snackbar = true;
              }
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      } else {
        this.snackbarText = "Ingrese el código que se muestra en la pantalla";
        this.snackbar = true;
      }
    },
  },
};
</script>